// Workflow landing corpus counts (GET /api/landing/stats).
import { http } from '@/services/http';
import { endpoints } from '@/services/endpoints';
import type { LandingStats } from '@/data/workflowCards';

export interface LandingService {
  getStats(): Promise<LandingStats>;
}

export const landingService: LandingService = {
  getStats: () => http<LandingStats>(endpoints.landing.stats),
};
